export const getClientCatalogPricingFields = (format) => ({
  regularPrice: Number(format.regularPrice ?? format.price ?? 0),
  manualDiscount: 0,
  clientPricingCandidateRules: format.candidateRules,
  clientPricingCategoryId: format.clientPricingCategoryId,
  clientPricingCategoryName: format.clientPricingCategoryName,
  clientPricingDiscountType: format.discountType,
  clientPricingDiscountValue: format.discountValue,
  clientPricingRuleType: format.ruleType,
  clientPricingMarginReductionPercent: format.marginReductionPercent,
  clientPricingReferenceCost: format.referenceCost?.referenceCostRaw
    ?? format.referenceCost?.referenceCost ?? format.referenceCostValue,
});

import {
  getFormatOfferId,
  getFormatOfferLineIssue,
  getSaleOptionId,
  isFormatOfferSelectable,
} from './formatOffers';

const getFormatLabel = (format) => (
  [format?.metricUnit, format?.description]
    .map((entry) => String(entry || '').trim())
    .filter(Boolean)
    .join(' · ') || 'Formato'
);

export const buildClientCatalogFormatMap = (catalog = []) => {
  const formats = new Map();
  (Array.isArray(catalog) ? catalog : []).forEach((product) => {
    (product?.Varieties || []).forEach((variety) => {
      (variety?.VarietyPrices || []).forEach((format, priceIndex) => {
        const saleOptionId = getSaleOptionId(format);
        if (!Number.isInteger(saleOptionId)) return;
        formats.set(saleOptionId, { product, variety, format, priceIndex });
      });
    });
  });
  return formats;
};

export const reconcileClientCatalogCart = (cart = {}, catalog = []) => {
  const formatMap = buildClientCatalogFormatMap(catalog);
  const unavailableIds = [];
  const nextCart = {};
  Object.entries(cart || {}).forEach(([key, item]) => {
    const saleOptionId = getSaleOptionId(item);
    const selection = formatMap.get(saleOptionId);
    if (!selection || selection.format?.isSoldOut || !isFormatOfferSelectable(selection.format)) {
      unavailableIds.push(saleOptionId);
      const pricingIssue = selection
        ? getFormatOfferLineIssue(item, selection.variety)
        : getFormatOfferId(item)
          ? {
            title: 'Oferta finalizada',
            detail: 'Retira esta línea y selecciona un precio vigente.',
          }
          : null;
      nextCart[key] = { ...item, pricingUnavailable: true, pricingIssue };
      return;
    }
    const { product, variety, format, priceIndex } = selection;
    const price = Math.max(Number(format.price || 0), 0);
    const discount = Math.min(Math.max(Number(format.discount || 0), 0), price);
    const finalPrice = Number.isFinite(Number(format.finalPrice))
      ? Math.max(Number(format.finalPrice), 0)
      : Math.max(price - discount, 0);
    const quantity = Number(item?.quantity || 0);
    nextCart[key] = {
      ...item,
      ...getClientCatalogPricingFields(format),
      varietyId: variety.id,
      varietyPriceId: Number(format.parentVarietyPriceId ?? format.id),
      ...(getFormatOfferId(format) ? { formatOfferId: getFormatOfferId(format) } : { formatOfferId: null }),
      priceIndex,
      productName: product.productName,
      productImage: product.productImage,
      varietyName: variety.varietyName,
      varietyImage: variety.varietyImage,
      priceImage: format.priceImage,
      metricUnit: format.metricUnit,
      description: getFormatLabel(format),
      price,
      discount,
      discountSource: getFormatOfferId(format)
        ? 'format_offer'
        : discount > 0 ? (format.discountSource || 'client_category') : 'none',
      finalPrice,
      subtotal: Math.floor(finalPrice * Math.max(quantity, 0)),
      pricingUnavailable: false,
      pricingIssue: null,
    };
  });
  return { cart: nextCart, unavailableIds };
};
